export default __webpack_public_path__ + "static/media/face-scan.c73db68b.svg";